import { render } from "./MailAccounts.vue?vue&type=template&id=93d56d58&scoped=true"
import script from "./MailAccounts.vue?vue&type=script&lang=js"
export * from "./MailAccounts.vue?vue&type=script&lang=js"

import "./MailAccounts.vue?vue&type=style&index=0&id=93d56d58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d56d58"]])

export default __exports__